export const COLORS = {
  '$main-30': '#E5F3FF4D',
  '$main-100': '#E5F3FF',
  '$main-200': '#B3DAFF',
  '$main-300': '#80C1FF',
  '$main-400': '#4DA8FF',
  '$main-500': '#1A8FFF',
  '$main-600': '#0076E6',
  '$main-700': '#005BB3',
  '$main-800': '#0D5799',
  '$main-900': 'rgba(28, 55, 78, 1)',
  '$main-999': '#000D1A',
  'custom-blue': '#0f6cbd',
};
